import { useMutation } from '@apollo/client';
import { Form, Input, Modal } from 'antd';
import { trimStart } from 'lodash';
import React, { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import { formValidatorRules } from '../../../common/utils';
import { CREATE_TRUCK, UPDATE_TRUCK } from '../graphql/Mutation';

const { required } = formValidatorRules;
const AddEditTruckModal = ({
  showModal,
  setShowModal,
  refetch,
  isEdit,
  editData,
  setEditData
}) => {
  const [form] = Form.useForm();
  const {
    state: { selectedFacilityId }
  } = useContext(AppContext);

  const [createTruck, { loading: createLoading }] = useMutation(CREATE_TRUCK, {
    onError() {}
  });

  const [updateTruck, { loading: updateLoading }] = useMutation(UPDATE_TRUCK, {
    onError() {}
  });

  const handleCancel = () => {
    setShowModal(false);
    setEditData();
  };
  const handleOk = () => {
    form.submit();
  };

  const onTrucksFinish = async (formValues) => {
    try {
      if (isEdit) {
        const response = await updateTruck({
          variables: {
            where: {
              id: editData?.id
            },
            data: {
              name: trimStart(formValues?.name),
              facilityId: selectedFacilityId
            }
          }
        });
        if (response?.data?.updateTruck) {
          setShowModal(false);
          form.resetFields();
          refetch();
          setEditData();
        }
      } else {
        const response = await createTruck({
          variables: {
            data: {
              name: trimStart(formValues?.name),
              facilityId: selectedFacilityId
            }
          }
        });
        if (response?.data?.createTruck) {
          setShowModal(false);
          form.resetFields();
          refetch();
          setEditData();
        }
      }
    } catch (error) {
      return error;
    }
  };

  return (
    <Modal
      visible={showModal}
      onCancel={handleCancel}
      title={`${isEdit ? 'Edit Truck' : 'Add Truck'}`}
      okText={`${isEdit ? 'Save' : 'Add'}`}
      onOk={handleOk}
      confirmLoading={createLoading || updateLoading}
      centered
    >
      <Form
        layout="vertical"
        onFinish={onTrucksFinish}
        form={form}
        initialValues={editData}
      >
        <Form.Item
          label="Name"
          rules={[required, { whitespace: true }]}
          name="name"
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddEditTruckModal;
